import * as d3 from 'd3';
import { ChartColors } from '/src/lib/types';

/**
 * Color Scale
 */

export interface ColorScaleProps {
  colorRange: ChartColors;
}

export class ColorScale implements ColorScaleProps {
  colorRange: ChartColors;
  colors: any = {};
  keys: string[];
  [key: string]: any;

  constructor(colorRange: ChartColors) {
    this.colorRange = colorRange;
    this.keys = Object.keys(this.colorRange);
    this.colors = {};

    for (const color in this.keys) {
      const key = this.keys[color];
      this.colors[key] = d3.scaleOrdinal(d3.schemeCategory10).range(this.colorRange[key]);
    }
  }
}
